/**
 * Maps an ISO country code to the child-privacy regulation that applies.
 *
 * Used only for the client-side informational prompt on the register page —
 * the server still enforces the age threshold via childAgeThreshold mirror.
 * Regulation name is a short i18n key, not a legal opinion; the Privacy
 * Policy page carries the full obligations.
 */

export type PrivacyRegulation =
  | 'COPPA'
  | 'GDPR_K'
  | 'TW_PDPA'
  | 'JP_APPI'
  | 'KR_PIPA'
  | 'CN_PIPL'
  | 'HK_PDPO'
  | 'SEA_PDPA'
  | 'IN_DPDPA'
  | 'CA_PIPEDA'
  | 'AU_PRIVACY'
  | 'INTERNATIONAL';

const GDPR_COUNTRIES = new Set([
  'AT', 'BE', 'BG', 'HR', 'CY', 'CZ', 'DK', 'EE', 'FI', 'FR', 'DE', 'GR',
  'HU', 'IE', 'IT', 'LV', 'LT', 'LU', 'MT', 'NL', 'PL', 'PT', 'RO', 'SK',
  'SI', 'ES', 'SE', 'GB',
]);

const SEA_PDPA_COUNTRIES = new Set(['SG', 'MY', 'TH', 'VN', 'ID', 'PH']);

export function getPrivacyRegulation(countryCode: string | null | undefined): PrivacyRegulation {
  if (!countryCode) return 'INTERNATIONAL';
  const code = countryCode.toUpperCase();
  if (code === 'US') return 'COPPA';
  if (GDPR_COUNTRIES.has(code)) return 'GDPR_K';
  if (code === 'TW') return 'TW_PDPA';
  if (code === 'JP') return 'JP_APPI';
  if (code === 'KR') return 'KR_PIPA';
  if (code === 'CN') return 'CN_PIPL';
  if (code === 'HK') return 'HK_PDPO';
  if (SEA_PDPA_COUNTRIES.has(code)) return 'SEA_PDPA';
  if (code === 'IN') return 'IN_DPDPA';
  if (code === 'CA') return 'CA_PIPEDA';
  if (code === 'AU' || code === 'NZ') return 'AU_PRIVACY';
  return 'INTERNATIONAL';
}
